// Core
import React, { FC } from 'react';
import { createPortal } from 'react-dom';
import { PieBar } from "../../../components/Charts";

const EmployeesGender: FC = () => {
  const params = new URLSearchParams(window.location.search)

  const apiParams = {
    name: "employees_gender",
    ot: params.get('ot'),
    date_from: params.get('date_from'),
    date_to: params.get('date_to'),
    filters: {
      team: params.getAll('team[]').filter(item => item !== 'all'),
    }
  };

  return <PieBar
    apiParams={apiParams}
  />;
}

function StatisticsByTeamsChart2Portal({ id }: { id: string }) {
  const Root = document.getElementById(id);
  return Root ? createPortal(<EmployeesGender/>, Root) : null;
}

export default StatisticsByTeamsChart2Portal;
